import { CAMPAIGN } from "constants/Define";
import BaseModel from "./BaseModel";
import moment from "moment";

export default class Bundle extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.campaignId = data.campaignId || this.translate.campaignId || undefined;
        this.campaignCode = data.campaignCode || this.translate.campaignCode || undefined;
        this.campaignName = data.campaignName || this.translate.campaignName || undefined;
        this.code = data.code || this.translate.code || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.totalCount = data.totalCount || this.translate.totalCount || 0;
        this.usedCount = data.usedCount || this.translate.usedCount || 0;
        this.rangeDate = data.rangeDate || undefined;
        this.isActive = typeof data.isActive == "boolean" ? data.isActive : 1;
        this.expiredDate = data.expiredDate || undefined;
        this.createdUserName = data.createdUserName || this.translate.createdUserName || undefined;
        this.createdDate = data.createdDate || this.translate.createdDate || undefined;
        this.startDate = data.startDate || this.translate.startDate || undefined;
        this.endDate = data.endDate || this.translate.endDate || undefined;
        this.count = data.count || this.translate.count || 0;
        this.campaignStartTime = data.campaignStartTime || this.translate.campaignStartTime || undefined;
        this.campaignEndTime = data.campaignEndTime || this.translate.campaignEndTime || undefined;
        this.dayOfWeek = Array.isArray(data.dayOfWeek) ? this.parseDayOfWeekFromArrToObj(data.dayOfWeek || []) : data.dayOfWeek;
        this.stayStartDate = data.stayStartDate || this.translate.stayStartDate || undefined;
        this.stayEndDate = data.stayEndDate || this.translate.stayEndDate || undefined;
        this.maxCount = data.maxCount || this.translate.maxCount || 0;
        this.promotionCodes = data.promotionCodes || [];
        this.isCampaignHotelType = data.isCampaignHotelType || null;
        this.loyaltyBenefitCode = data.loyaltyBenefitCode || undefined;
        this.code = data.code || undefined;
        this.isCheckExpiredCard = data.isCheckExpiredCard || false;
        this.isCheckExpiredVoucher = data.isCheckExpiredVoucher || false;
        this.checkinDateLimitType = data.checkinDateLimitType || CAMPAIGN.DATE_LIMIT.NONE.key;
        this.checkinDateLimitValue = data.checkinDateLimitValue || {
            dateRanges: null,
            dates: [],
            dayOfWeek: null,
        };
    }

    parseDayOfWeekFromArrToObj(arrDayOfWeek) {
        let result = {};
        if (arrDayOfWeek && arrDayOfWeek.length > 0) {
            (moment.localeData('en').weekdays() || []).map((day, index) => {
                const isAllowAdd = arrDayOfWeek.filter(item => { return item === index });
                result = isAllowAdd && isAllowAdd.length > 0 ? Object.assign(result, { [`${day.toLowerCase()}`]: true }) : result;
            })
        }
        return result;
    }

    parseDayOfWeek(data) {
        let result = [];
        if (data && Object.keys(data).length > 0) {
            (moment.localeData('en').weekdays() || []).map((day, index) => {
                const dayKey = day.toLowerCase();
                if (dayKey && data[dayKey]) {
                    result.push(index);
                }
            })
        }
        return result ? result.sort() : result;
    }

    exportChangeStatus() {
        return {
            id: this.id,
            isActive: this.isActive,
        }
    }

    export() {
        return {
            campaignId: this.campaignId,
            name: this.name ? this.name.trim() : this.name,
            count: this.count || 0,
            // startDate: this.startDate ? moment(this.startDate).toISOString() : undefined,
            // endDate: this.endDate ? moment(this.endDate).toISOString() : undefined,
            startDate: this.startDate && this.startDate.utcOffset(0, true).format(),
            endDate: this.endDate && this.endDate.utcOffset(0, true).format(),
            // stayStartDate: this.stayStartDate ? moment(this.stayStartDate).toISOString() : undefined,
            // stayEndDate: this.stayEndDate ? moment(this.stayEndDate).toISOString() : undefined,
            stayStartDate: this.stayStartDate ? this.stayStartDate.utcOffset(0, true) : undefined,
            stayEndDate: this.stayEndDate ? this.stayEndDate.utcOffset(0, true) : undefined,
            dayOfWeek: this.parseDayOfWeek(this.dayOfWeek),
            isActive: true,
            loyaltyBenefitCode: this.loyaltyBenefitCode,
            promotionCodes: this.promotionCodes || [],
            isCheckExpiredCard: this.isCheckExpiredCard || false,
            isCheckExpiredVoucher: this.isCheckExpiredVoucher || false,
            checkinDateLimitType: this.checkinDateLimitType || CAMPAIGN.DATE_LIMIT.NONE.key,
            checkinDateLimitValue: this.checkinDateLimitValue || {
                dateRanges: null,
                dates: [],
                dayOfWeek: null,
            }
        }
    }
}
